import { AppBar, Box, Button, Container, Drawer, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material'
// import RestaurantMenuPopup from 'pages/dashboard/ui/Restaurant-Menu-Popup'
import React, { useMemo } from 'react'
import defaultImg from "assests/Serve-link-default.png";
import menuBar from "assests/Group 128.svg"
import { useThemeContext } from 'theme/ThemeContext2';
import MenuIcon from "@mui/icons-material/Menu"
import RestaurantMenuPopup from './MenuDrawer';
import "./style.css";
import { useLocation, useNavigate } from 'react-router-dom';

const POSHeaderContainer = ({
  navButtons,
  navList,
  toggleDrawer,
  handleMenuClose,
  handleLogoClick,
  ImgIcon,
  userData,
  isMenuOpen,
  drawerOpen,
  logoRef
}) => {
  const { themeData } = useThemeContext()
  const { pathname } = useLocation();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const activeColor = theme.palette.highlight.main;
  const navigate = useNavigate();

  const logoSrc = useMemo(() => {
    return themeData?.brand_logo
      ? `${process.env.REACT_APP_API_ROUTE}/files/${themeData?.brand_logo}`
      : '';
  }, [themeData]);

  const vendorlogoSrc = useMemo(() => {
    return userData?.vendor?.image
      ? `${process.env.REACT_APP_API_ROUTE}/files/${userData.vendor.image}`
      : '';
  }, [userData]);

  return (
    <AppBar position="sticky" sx={{ bgcolor: theme.palette.primary.main, boxShadow: "none", borderRadius: 0 }}>
      <Container
        maxWidth={false}
        className='pos-header-container'
        disableGutters
        sx={{
          maxWidth: "1400px",
          mx: "auto",
          px: { xs: 1, sm: 2, md: 3 },
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, px: 0 }}>
          <img
            // src={
            //   `${process.env.REACT_APP_API_ROUTE}/files/${themeData?.brand_logo}` ||
            //   defaultImg
            // }
            src={logoSrc}
            alt="POS Logo"
            className='pos-logo-header'
            loading="lazy"
            decoding="async"
            style={{
              width: isMobile ? 80 : 100,
              cursor: 'pointer'
            }}
            onClick={() => navigate('/')}
          />

          {isMobile ? (
            // <IconButton
            //   color="inherit"
            //   aria-label="open drawer"
            //   edge="start"
            //   onClick={toggleDrawer(true)}
            //   className='menu-icon-drawer'
            // >
            //   <MenuIcon />
            // </IconButton>
            <></>
          ) : (
            <>
              {navButtons.map((item, index) => {
                // const selected = item.activePaths
                //     ? item.activePaths.includes(pathname)
                //     : pathname == item.path;
                const selected = item.activePaths
                  ? item.activePaths.some(p => pathname === p || pathname.startsWith(p + '/'))
                  : pathname === item.path || pathname.startsWith(item.path + '/');

                return (
                  <Button
                    key={index}
                    color="inherit"
                    startIcon={ImgIcon(selected ? item.activeIcon : item.icon, item.label, '18px', '18px')}
                    onClick={() => navigate(item?.path)}
                    sx={{
                      // color: item.color, 
                      mx: 1, display: { xs: "none", md: "flex" }, textTransform: "none",
                      color: selected ? activeColor : theme.palette.secondary.main,
                      lineHeight: '1.5'
                    }}
                  >
                    {item.label}
                  </Button>
                )
              })}
            </>
          )}

          <Box sx={{ flexGrow: 1 }} />

          {/* Combined logo + menu icon container */}
          <Box
            ref={logoRef}
            onClick={handleLogoClick}
            className='header-list-item'
          >
            <img
              // src={
              //   userData?.vendor?.image
              //     ? `${process.env.REACT_APP_API_ROUTE}/files/${userData.vendor.image}`
              //     : defaultImg
              // }
              src={vendorlogoSrc}
              loading="lazy"
              decoding="async"
              alt="Restaurant Logo"
              className='list-menu-icon'
            />
            {!isMenuOpen && (
              <img
                src={menuBar}
                alt="Menu"
                className='menu-open-bar'
              />
            )}
          </Box>

          {/* Close button */}
          {isMenuOpen && (
            <Box
              className='close-menu-icon'
              onClick={handleMenuClose}
            >
              <Typography className='close-icon-drawer'>×</Typography>
            </Box>
          )}

          {/* Restaurant Menu Popup */}
          <RestaurantMenuPopup
            anchorEl={logoRef.current}
            open={isMenuOpen}
            onClose={handleMenuClose}
            restaurantName={userData?.vendor?.name}
            restaurantDescription={userData?.vendor?.tagline}
            logoSrc={userData?.vendor?.image}
          />

          {/* Mobile Navigation Drawer */}
          <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
            <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
              {navList}
            </Box>
          </Drawer>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default React.memo(POSHeaderContainer);
